import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-4"},[_c('div',{staticClass:"pb-3"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.$t('commentWithOrder'))+":")]),_vm._v(" "),_c('span',{staticClass:"font-italic text--secondary"},[_vm._v(_vm._s(_vm.customerComment))])]),_c(VDivider)],1)}
var staticRenderFns = []

export { render, staticRenderFns }